import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';

// TODO: We can use boostrap's own pagination if needed, but it only has buttons for pages, not the other UI components like choose page size.
// https://react-bootstrap.github.io/components/pagination/

interface PaginationProps {
    canPreviousPage: boolean;
    canNextPage: boolean;
    pageCount: number;
    pageOptions: number[];
    pageIndex: number;
    gotoPage: Function;
    previousPage: Function;
    nextPage: Function;
    pageSize: number;
    setPageSize: Function;
}

const PaginationButtonGroups = (props: PaginationProps) => {
    const {
        canPreviousPage,
        canNextPage,
        pageCount,
        pageOptions,
        gotoPage,
        previousPage,
        nextPage,
        pageIndex,
        pageSize,
        setPageSize,
    } = props;

    const [index, setIndex] = useState(pageIndex + 1);

    useEffect(() => {
        setIndex(pageIndex + 1);
    }, [pageIndex]);

    return pageOptions.length > 0 ? (
        <div className="container">
            <div className="row">
                <div className="col-2 col-sm-3">
                    <Button
                        variant="secondary"
                        onClick={() => previousPage()}
                        disabled={!canPreviousPage}
                        className="pagination-visible-btns  d-inline float-right"
                    >
                        {'<'}
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => gotoPage(0)}
                        disabled={!canPreviousPage}
                        className="pagination-mobile-hide-btns  d-inline float-right"
                    >
                        {'<<'}
                    </Button>{' '}
                </div>

                <div className="col-4 col-sm-3 pagination-size">
                    <input
                        type="number"
                        value={index}
                        onChange={(e) => {
                            if (
                                !Number.isNaN(e.target.value) &&
                                Number(e.target.value) >= 1 &&
                                Number(e.target.value) <= pageOptions.length
                            ) {
                                setIndex(Number(e.target.value));
                            }
                        }}
                        onBlur={() => {
                            const gotopage = index - 1;
                            gotoPage(gotopage);
                        }}
                        className="w-50 mr-1 text-center"
                    />
                    / {pageOptions.length}
                </div>

                <div className="col-4 col-sm-3">
                    <select
                        value={pageSize}
                        className="pagination-size"
                        onChange={(e) => {
                            setPageSize(Number(e.target.value));
                        }}
                    >
                        {[5, 10, 20, 50, 100].map((size) => (
                            <option key={size} value={size}>
                                {size} rows
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-2 col-sm-3">
                    <Button
                        variant="secondary"
                        onClick={() => nextPage()}
                        disabled={!canNextPage}
                        className="pagination-visible-btns d-inline"
                    >
                        {'>'}
                    </Button>{' '}
                    <Button
                        variant="secondary"
                        onClick={() => gotoPage(pageCount - 1)}
                        disabled={!canNextPage}
                        className="pagination-mobile-hide-btns d-inline"
                    >
                        {'>>'}
                    </Button>{' '}
                </div>
            </div>
        </div>
    ) : null;
};

export default PaginationButtonGroups;
